export default __webpack_public_path__ + "static/media/Untitled3.90a6a090.jpg";